import React, { useEffect, useState } from 'react';
import BaseModal from './BaseModal';
import { INPUT } from './ui';

const PromptModal = ({
  open,
  title,
  message,
  defaultValue = '',
  placeholder = '',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  inputType = 'text',
  required = false,
  onConfirm,
  onCancel,
}) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    if (open) {
      setValue(defaultValue);
    }
  }, [open, defaultValue]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (required && !value.trim()) return;
    onConfirm(value);
  };

  return (
    <BaseModal
      open={open}
      titleId="prompt-modal-title"
      title={title}
      message={message}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      selectOnOpen
    >
      <input
        type={inputType}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        required={required}
        className={INPUT}
      />
    </BaseModal>
  );
};

export default PromptModal;
